<template>
  <v-row class="align-center">
    <v-col cols="3" class="subtitle-2">Tax</v-col>
    <v-col><f-percent outlined hide-details dense :value="value" @input="updateValue($event)" /></v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    value: String,
  },
  methods: {
    updateValue(newPercent) {
      this.$emit("input", newPercent || null);
    },
    clear() {
      this.$emit("input", null);
    },
  },
};
</script>
